<template>
  <BarChart v-bind:title="title" v-bind:data="data" />
</template>

<script>
import BarChart from "@/components/management/statistics/common/BarChart";
import { getDocViewChartData } from "@/api/statistics";

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      title: "Document View",
      data: [],
    };
  },
  // created() {
  //   this.getData();
  // },
  methods: {
    async getData(year, firstDoctype, firstProdType, secondProdType) {
      console.log(year);
      let loader = this.$loading.show({});
      try {
        let response = await getDocViewChartData(
          year,
          firstDoctype,
          firstProdType,
          secondProdType
        );
        this.data = response.data.result;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style></style>
